import React, { useContext, useState, useEffect } from "react";
import { Context } from "../contexts/AppContext";
import { deleteData, postData, putData } from "../../lib/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faChevronLeft,
  faChevronRight,
  faXmark,
  faDownload,
  faCloudArrowDown
} from "@fortawesome/free-solid-svg-icons";
import Masonry from "react-masonry-css";
import ReplacePhoto from "../../components/Gallery/ReplacePhoto";

function PhotoThumbnail() {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const [confirmDeleteAll, setConfirmDeleteAll] = useState(false);
const [confirmDeleteSelected, setConfirmDeleteSelected] =
  useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectionMode, setSelectionMode] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [processingPhotos, setProcessingPhotos] = useState({});
  const [activeTab, setActiveTab] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPhotos, setSelectedPhotos] = useState([]);
  const breakpointColumnsObj = {
    default: 4,
    1100: 3,
    700: 2,
  };

  const handleDownload = async (url, filename) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();

    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename || "image.jpg";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Download failed:", error);
  }
};

  const deleteSelectedPhotos = async () => {
  try {
    const photosToDelete = (appState.photoArr || []).filter((p) =>
      selectedPhotos.includes(p._id)
    );

    for (const photo of photosToDelete) {
      await postData("products/delete-file", {
        fileName: photo.url,
      });

      await deleteData(`photos/deletePhoto/${photo._id}`);
    }

    setAppState((prev) => ({
      ...prev,
      photoArr: prev.photoArr.filter(
        (p) => !selectedPhotos.includes(p._id)
      ),
    }));

    setSelectedPhotos([]);
    setConfirmDeleteSelected(false);
  } catch (err) {
    console.error(err);
  }
};
const togglePhotoSelection = (photoId) => {
  setSelectedPhotos((prev) =>
    prev.includes(photoId)
      ? prev.filter((id) => id !== photoId)
      : [...prev, photoId]
  );
};
  const deleteAllPhotos = async () => {
  try {
    const photos = [...(appState?.photoArr || [])];

    for (const photo of photos) {
      await postData("products/delete-file", {
        fileName: photo.url,
      });

      await deleteData(`photos/deletePhoto/${photo._id}`);
    }

    setAppState((prev) => ({
      ...prev,
      photoArr: [],
    }));

    setConfirmDeleteAll(false);
  } catch (err) {
    console.error(err);
  }
};
  // -----------------------------------
  // CATEGORY FROM FILE NAME
  // -----------------------------------
const getCategory = (fileName = "") => {
  const name = fileName.split("/").pop();

  const noExt = name.replace(/\.[^/.]+$/, "");
  const noNumber = noExt.replace(/[0-9]/g, "");
  const clean = noNumber.replace(/[_-]/g, "").trim();

  return clean.toLowerCase();
};
  // -----------------------------------
  // AUTO TABS
  // -----------------------------------
const tabs = [
  "All",
  "Favorites",
  ...new Set(
    (appState?.photoArr || [])
      .map((item) =>
        item.folderName?.trim()
          ? item.folderName
          : getCategory(item.title)
      )
      .filter(Boolean)
  ),
];

  // -----------------------------------
  // FILTER PHOTOS
  // -----------------------------------

const filteredPhotos = (appState?.photoArr || []).filter((item) => {
  const category = item.folderName?.trim()
    ? item.folderName
    : getCategory(item.title);

  const matchesTab =
    activeTab === "All"
      ? true
      : activeTab === "Favorites"
      ? item.favorites
      : category === activeTab;

  const matchesSearch =
    !searchTerm ||
    item.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    category?.toLowerCase().includes(searchTerm.toLowerCase());

  return matchesTab && matchesSearch;
});
  // -----------------------------------
  // IMAGE CHECK
  // -----------------------------------
  const checkImageExists = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
    });
  };

  const waitForImage = async (url, retries = 10, delay = 1000) => {
    for (let i = 0; i < retries; i++) {
      const exists = await checkImageExists(url);
      if (exists) return true;
      await new Promise((res) => setTimeout(res, delay));
    }
    return false;
  };

  // -----------------------------------
  // REPLACE PHOTO
  // -----------------------------------
  const replaceUploadPhotoDone = async (
    fileName,
    uniqueId,
    photoId,
    oldPhotoUrl
  ) => {
    try {
      const newUrl = `${appState.currentFolderData.adminId}/${appState.currentFolderData.id}/${appState.currentGalleryData._id}/${fileName}`;

      setProcessingPhotos((prev) => ({
        ...prev,
        [photoId]: true,
      }));

      await putData(`photos/updatePhoto/${photoId}`, {
        url: newUrl,
      });

      await postData("products/delete-file", {
        fileName: oldPhotoUrl,
      });

      const fullUrl = `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${newUrl}`;

      await waitForImage(fullUrl);

      setAppState((prev) => ({
        ...prev,
        photoArr: prev.photoArr.map((p) =>
          p._id === photoId ? { ...p, url: newUrl } : p
        ),
      }));

      setProcessingPhotos((prev) => {
        const updated = { ...prev };
        delete updated[photoId];
        return updated;
      });
    } catch (err) {
      console.error(err);
    }
  };

  // -----------------------------------
  // NAVIGATION
  // -----------------------------------
  const nextImage = () => {
    setSelectedIndex((prev) =>
      prev === filteredPhotos.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setSelectedIndex((prev) =>
      prev === 0 ? filteredPhotos.length - 1 : prev - 1
    );
  };

  useEffect(() => {
    const handleKey = (e) => {
      if (selectedIndex === null) return;
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
      if (e.key === "Escape") setSelectedIndex(null);
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [selectedIndex, filteredPhotos]);

  // -----------------------------------
  // DELETE PHOTO
  // -----------------------------------
  const deletePhoto = async () => {
    if (!confirmDelete) return;

    try {
      await postData("products/delete-file", {
        fileName: confirmDelete.url,
      });

      await deleteData(`photos/deletePhoto/${confirmDelete._id}`);

      setAppState((prev) => ({
        ...prev,
        photoArr: prev.photoArr.filter(
          (p) => p._id !== confirmDelete._id
        ),
      }));

      setConfirmDelete(null);
    } catch (err) {
      console.error(err);
    }
  };

  const formatDate = (iso) => {
    const d = new Date(iso);
    return d.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <>
      {/* -------------------- */}
      {/* CATEGORY TABS */}
      {/* -------------------- */}
      <div className="flex overflow-x-auto justify-between px-4">
 <div>
{tabs.map((tab, i) => {
  const count =
    tab === "All"
      ? (appState?.photoArr || []).length
      : tab === "Favorites"
      ? (appState?.photoArr || []).filter(
          (p) => p.favorites
        ).length
      : (appState?.photoArr || []).filter((item) => {
          const category = item.folderName?.trim()
            ? item.folderName
            : getCategory(item.title);

          return category === tab;
        }).length;

  return (
    <button
      key={i}
      onClick={() => {
        setActiveTab(tab);
        setSelectedIndex(null);
      }}
      className={`relative px-6 py-2 text-sm uppercase tracking-wide whitespace-nowrap transition-all duration-200 ${
        activeTab === tab
          ? "text-[#7a0a02] border-b-4 border-[#a52a1f]"
          : "text-[#7a0a02] hover:text-black"
      }`}
    >
      {tab} ({count})

      {activeTab === tab && (
        <span className="absolute left-0 bottom-0 h-[2px] w-full bg-white"></span>
      )}
    </button>
  );
})}
        </div>

               <div className="text-lg font-semibold text-[#7a0a02] px-6 py-2 ">
  Gallery Photos: {appState?.photoArr?.length || 0}
        </div>
     
</div>
      
    
      
<div className="flex justify-between items-center px-2 py-2">
   

  <div className="px-2 py-2 w-64">
  <input
    type="text"
    placeholder="Search images..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    className="w-full border rounded-lg px-4 py-2 outline-none"
  />
        </div>
<div className="gap-2 flex">

        <button
  onClick={() =>
    setSelectedPhotos(filteredPhotos.map((p) => p._id))
  }
  className="bg-gray-600 text-white px-4 py-2 rounded"
>
  Select All
        </button>
      {selectedPhotos.length > 0 && (  <button
  onClick={() => setSelectedPhotos([])}
  className="bg-gray-600 text-white px-4 py-2 rounded"
>
  Clear Selection
        </button>
        )}
                {selectedPhotos.length > 0 && (
  <button
    onClick={() => setConfirmDeleteAll(true)}
    className="bg-red-600 text-white px-4 py-2 rounded-lg"
  >
    Delete Selected ({selectedPhotos.length})
  </button>
)}
 </div>
</div>
      {/* -------------------- */}
      {/* GRID */}
      {/* -------------------- */}
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="flex gap-4 p-2 overflow-auto h-[calc(100vh-260px)]"
        columnClassName="space-y-4"
      >
        {filteredPhotos.map((item, index) => (
          <div
            key={item._id}
            className="border rounded-lg bg-[#404143] relative overflow-hidden"
          >
            <div className="relative">
      <img
  src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${item.url.replace(
    /\/([^/]+)$/,
    "/thumbs/$1"
  )}`}
  alt={item.title}
  className="w-full h-auto cursor-pointer"
  loading="lazy"
  onError={(e) => {
    e.currentTarget.onerror = null;

    e.currentTarget.src =
      `${process.env.REACT_APP_VIDEO_TEST_BASE_PATH}${item.url}`;
  }}
/>

              {processingPhotos[item._id] && (
                <div className="absolute inset-0 bg-black/60 flex flex-col items-center justify-center text-white">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white mb-2"></div>
                  Processing...
                </div>
              )}
            </div>

            <div className="p-2 text-white text-sm">
              <div className="text-xs opacity-70">{item.title}</div>

              <div className="flex justify-between mt-1">
                <div className="text-xs opacity-70">
                  {formatDate(item.createdAt)}
                </div>
                  <div className="absolute top-2 left-2">
  <input
    type="checkbox"
    checked={selectedPhotos.includes(item._id)}
    onChange={() => togglePhotoSelection(item._id)}
    className="h-5 w-5 cursor-pointer"
  />
</div>
               <div className="space-x-2 flex">
  <FontAwesomeIcon
                    icon={faCloudArrowDown}
                      onClick={(e) => {
      e.stopPropagation();
      handleDownload(
        `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${item?.url}`,
        item?.title
      );
    }}
    
    className="cursor-pointer hover:text-green-400 text-lg"
  />

  <FontAwesomeIcon
    icon={faTrash}
    onClick={(e) => {
      e.stopPropagation();
      setConfirmDelete(item);
    }}
    className="cursor-pointer hover:text-red-400 text-lg"
  />
</div>
              </div>
            </div>
          </div>
        ))}
      </Masonry>

      {/* -------------------- */}
      {/* FULLSCREEN */}
      {/* -------------------- */}
      {selectedIndex !== null && filteredPhotos[selectedIndex] && (
        <div className="fixed inset-0 bg-black z-50 flex items-center justify-center">
          <button
            onClick={() => setSelectedIndex(null)}
            className="absolute top-16 right-4 text-white text-4xl"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>

          <button
            onClick={prevImage}
            className="absolute left-4 text-white text-3xl"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

        <img
  src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${filteredPhotos[selectedIndex]?.url}`}
  alt=""
  className="max-h-screen max-w-screen object-contain mx-auto my-auto p-16 mt-8"
/>

          <button
            onClick={nextImage}
            className="absolute right-4 text-white text-3xl"
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      )}

      {/* -------------------- */}
      {/* DELETE MODAL */}
      {/* -------------------- */}
      {confirmDelete && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center">
          <div className="bg-white rounded-xl p-6 w-[400px]">
            <h2 className="mb-4">
              Delete this photo? Storage (GB) won’t be recovered.
            </h2>

            <div className="flex justify-center gap-4">
              <button
                onClick={() => setConfirmDelete(null)}
                className="px-4 py-2 bg-gray-300 rounded"
              >
                Cancel
              </button>

              <button
                onClick={deletePhoto}
                className="px-4 py-2 bg-red-500 text-white rounded"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {confirmDeleteAll && (
  <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center">
    <div className="bg-white rounded-xl p-6 w-[450px]">
      <h2 className="text-lg font-semibold mb-4">
        Delete ALL photos?
      </h2>

      <p className="mb-6 text-gray-600">
        This action cannot be undone.
      </p>

      <div className="flex justify-center gap-4">
        <button
          onClick={() => setConfirmDeleteAll(false)}
          className="px-4 py-2 bg-gray-300 rounded"
        >
          Cancel
        </button>

        <button
          onClick={deleteAllPhotos}
          className="px-4 py-2 bg-red-600 text-white rounded"
        >
          Delete All
        </button>
      </div>
    </div>
  </div>
)}
    </>
  );
}

export default PhotoThumbnail;